import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import { ProductAiInsightsRootModalScreenParamList } from "../../../../types";
import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { ScreenContext } from "./common";
import { ProductAiInsightsScreen } from "./ProductAiInsightsScreen";
import React from "react";
import { ProductAiInsightsActionsRootScreen } from "./ProductAiInsightsActionsRootScreen";

const Stack =
  createStackHeaderNavigator<ProductAiInsightsRootModalScreenParamList>();

export interface ProductAiInsightsRootModalScreenProps
  extends StackScreenProps<
    {
      ProductAiInsightsRootModalScreen: {
        startDate?: string;
        productId: string;
        endDate?: string;
      };
    },
    "ProductAiInsightsRootModalScreen"
  > {}

export const ProductAiInsightsRootModalScreen = ({
  route,
}: ProductAiInsightsRootModalScreenProps) => {
  const { startDate, endDate, productId } = route.params;

  const normalizedStartDate = React.useMemo(() => {
    if (startDate) {
      return new Date(startDate);
    }
    const now = new Date();
    const localMidnight = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() - 30,
      0,
      0,
      0,
      0,
    );

    return localMidnight;
  }, [startDate]);

  return (
    <ScreenContext.Provider
      value={{
        startDate: normalizedStartDate,
        endDate: endDate ? new Date(endDate) : undefined,
        productId,
      }}
    >
      <Stack.Navigator
        screenOptions={{
          headerShown: true,
          title: ``,
          headerLeft: () => <ModalCloseButton type="Close" />,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        }}
      >
        <Stack.Screen
          name="ProductAiInsightsScreen"
          component={ProductAiInsightsScreen}
        />
        <Stack.Group
          screenOptions={{
            headerShown: false,
            presentation: "modal",
          }}
        >
          <Stack.Screen
            name="ProductAiInsightsActionsRootScreen"
            component={ProductAiInsightsActionsRootScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    </ScreenContext.Provider>
  );
};
